// Liga o MESMO produto (casado por código) entre os módulos Rampa de lançamentos
// e Saída de linha: pré-preenche o cadastro a partir do outro módulo e mantém a
// foto compartilhada, para não repreencher tudo.
import { supabase } from './supabase';

export interface ProductLink {
  name: string;
  brandId: string | null;
  gramatura: string | null;
  photoUrl: string | null;
  from: 'rampa' | 'saida';
}

/** Procura o produto (por código) no OUTRO módulo, para pré-preencher o cadastro. */
export async function lookupProductByCodigo(
  orgId: string,
  codigo: string,
): Promise<ProductLink | null> {
  const code = codigo.trim();
  if (!code) return null;
  const { data: r } = await supabase
    .from('launch_ramps')
    .select('name, brand_id, gramatura, photo_url')
    .eq('org_id', orgId)
    .eq('codigo', code)
    .limit(1);
  const rr = (r ?? [])[0] as Record<string, unknown> | undefined;
  if (rr) {
    return {
      name: rr.name as string,
      brandId: (rr.brand_id as string) ?? null,
      gramatura: (rr.gramatura as string) ?? null,
      photoUrl: (rr.photo_url as string) ?? null,
      from: 'rampa',
    };
  }
  const { data: d } = await supabase
    .from('discontinuations')
    .select('name, brand_id, photo_url')
    .eq('org_id', orgId)
    .eq('codigo_interno', code)
    .limit(1);
  const dd = (d ?? [])[0] as Record<string, unknown> | undefined;
  if (dd) {
    return {
      name: dd.name as string,
      brandId: (dd.brand_id as string) ?? null,
      gramatura: null,
      photoUrl: (dd.photo_url as string) ?? null,
      from: 'saida',
    };
  }
  return null;
}

/** Replica a foto (URL) do produto nos dois módulos, casando pelo código. */
export async function syncProductPhoto(
  orgId: string,
  codigo: string | null | undefined,
  photoUrl: string,
): Promise<void> {
  const code = (codigo ?? '').trim();
  if (!code || !photoUrl) return;
  await supabase.rpc('sync_product_photo', { p_org: orgId, p_codigo: code, p_url: photoUrl });
}
